import { TopLevelSpec as VegaLiteSpec } from 'vega-lite';
import { TimeUnit } from 'vega-lite/build/src/timeunit';
import { liteBaseConfig } from '../vegaShared';

export interface ICancellationTimelineOptions {
  data: any[];
  timeUnit: TimeUnit;
  xField: string;
  yField: string;
  color?: string;
  xAxisTitle?: string;
  yAxisTitle?: string;
  xLabels?: boolean;
  yLabels?: boolean;
  width?: number | 'container';
  height?: number | 'container';
}

export const genCancellationTimelineSpec = (options: ICancellationTimelineOptions): VegaLiteSpec => {
  const xAxis = { labelAngle: 0, title: options.xAxisTitle || null, labels: !!options.xLabels, domain: !!options.xLabels, ticks: !!options.xLabels };
  const yAxis = { title: options.yAxisTitle || null, labels: !!options.yLabels, domain: !!options.yLabels, ticks: !!options.yLabels };
  const config = {
    ...liteBaseConfig(),
  };
  const baseSpec: VegaLiteSpec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
    autosize: 'fit',
    width: options.width || 'container',
    height: options.height || 250,
    mark: {
      type: 'line',
      point: true,
      tooltip: true,
      color: options.color || '#6d6156',
      strokeWidth: 2,
    },
    config,
    transform: [
      {
        timeUnit: options.timeUnit,
        field: options.xField,
        as: options.timeUnit,
      },
      {
        aggregate: [
          {
            op: 'count',
            as: 'count_by_period',
          },
        ],
        groupby: [options.timeUnit, options.yField],
      },
    ],
    encoding: {
      x: { field: options.timeUnit, type: 'temporal', axis: xAxis },
      y: { type: 'quantitative', field: 'count_by_period', axis: yAxis },
      color: { type: 'nominal', field: options.yField, title: null },
    },
    data: { values: options.data },
  };
  return baseSpec;
};
